import styled from "styled-components";
import { theme } from "styles/theme";

export const Overline = styled.h5`
  color: ${theme.color.subtext3};
`;
